module.exports = __webpack_public_path__ + "img/warn_06.5dc538d6.png";